<script setup lang="ts">
withDefaults(defineProps<{ error?: string; label?: string }>(), { label: "正在整理内容索引" });
</script>

<template>
  <div class="loading-state" role="status">
    <span v-if="!error" class="loading-line" aria-hidden="true"></span>
    <strong>{{ error ? "内容暂时无法读取" : label }}</strong>
    <p v-if="error">{{ error }}</p>
  </div>
</template>
